import React from 'react';
import { CheckIcon } from 'lucide-react';
export const POISelector = ({
  poiCategories,
  selectedPOIs,
  togglePOI
}) => {
  return <div className="bg-white rounded-lg shadow-lg p-3 w-64" data-id="element-178">
      <h3 className="font-semibold mb-2 text-gray-800" data-id="element-179">Show on map:</h3>
      <div className="space-y-2" data-id="element-180">
        {poiCategories.map(category => <div key={category.type} className="flex items-center gap-2 cursor-pointer p-2 hover:bg-gray-50 rounded-md" onClick={() => togglePOI(category.type)} data-id="element-181">
            <div className={`w-5 h-5 rounded-md flex items-center justify-center ${selectedPOIs.includes(category.type) ? 'bg-rose-500' : 'border border-gray-300'}`} data-id="element-182">
              {selectedPOIs.includes(category.type) && <CheckIcon size={14} className="text-white" data-id="element-183" />}
            </div>
            <div className="flex items-center gap-2" data-id="element-184">
              <img src={category.icon} alt={category.label} className="w-5 h-5" data-id="element-185" />
              <span data-id="element-186">{category.label}</span>
            </div>
          </div>)}
      </div>
    </div>;
};